import { gql } from '@apollo/client'
import { ADMIN_AUDIT_INVENTORY_ITEM_FRAGMENT } from './AdminAuditInventoryItemFragment'

export const ADMIN_WHOLE_DISPLAY_AUDIT_FRAGMENT = gql`
  fragment AdminWholeDisplayAudit on DisplayAudit {
    __typename
    id
    predictions
    products {
      ...AdminAuditInventoryItem
    }
    dateCompleted
    display {
      id
      area
      displayType
      shortDescription
      isCompetitor
    }
    employee {
      id
      email
    }
    images {
      id
      url
    }
  }
  ${ADMIN_AUDIT_INVENTORY_ITEM_FRAGMENT}
`
